import axios from 'axios';
import { refreshAccessToken } from './authRefresh';

const API_BASE_URL = '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const isAuthEndpoint = original?.url?.includes('/auth/login') || original?.url?.includes('/auth/refresh');

    if (error.response?.status === 401 && original && !original._retriedAfterRefresh && !isAuthEndpoint) {
      original._retriedAfterRefresh = true;
      // Try a silent token refresh before giving up on the session — previously
      // this logged the user out immediately on any 401, even though a working
      // refresh token usually made that unnecessary.
      const newToken = await refreshAccessToken();
      if (newToken) {
        original.headers.Authorization = `Bearer ${newToken}`;
        return api(original);
      }
      // refreshAccessToken() already cleared storage + redirected to /login on failure.
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export const authService = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  refresh: (refreshToken) => api.post('/auth/refresh', { refreshToken }),
};

export const introducerService = {
  create: (data) => api.post('/introducers', data),
  list: () => api.get('/introducers'),
};

export const dealService = {
  create: (data) => api.post('/deals', data),
  list: () => api.get('/deals'),
  overrideFee: (dealId, data) => api.patch(`/deals/${dealId}/override-fee`, data),
};

export default api;
